var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"className":"home"}},[_c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js App"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }